import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISupport_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISupport_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class Support_ScreenBase extends React.PureComponent<
  ISupport_ScreenProps,
  any
> {
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "597cafda-5182-4345-8b3c-eff108362cb3",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 60722,
          PropertyName: "value",
          Value: "Pastel Design Boss Screen Support - English",
        },
        {
          Id: 158308,
          PropertyName: "value",
          Value:
            "Pastel Design Boss Screen is an ERP-integrated mobile application developed by Detay Yazılım. For any support requests related to the application, you can contact us using the information below.",
        },
        {
          Id: 759819,
          PropertyName: "value",
          Value:
            "Company: Detay Yazılım Application: Pastel Design Boss Screen",
        },
        {
          Id: 830234,
          PropertyName: "value",
          Value: "Email: mert@detayyazilim.net",
        },
        { Id: 590678, PropertyName: "value", Value: "Phone: +90 532 640 3296" },
        { Id: 814980, PropertyName: "value", Value: "Support Scope:" },
        {
          Id: 756591,
          PropertyName: "value",
          Value: "User login and access issues",
        },
        {
          Id: 615164,
          PropertyName: "value",
          Value: "Order, stock, and invoicing processes",
        },
        {
          Id: 939558,
          PropertyName: "value",
          Value: "ERP integration and data synchronization",
        },
        {
          Id: 266658,
          PropertyName: "value",
          Value: "Technical errors and performance issues",
        },
        { Id: 906580, PropertyName: "value", Value: "General usage support" },
        {
          Id: 8515,
          PropertyName: "value",
          Value:
            "All support requests will be reviewed and responded to as soon as possible.",
        },
        {
          Id: 306659,
          PropertyName: "value",
          Value: "Pastel Design Patron Ekranı Destek - Türkçe",
        },
        {
          Id: 282347,
          PropertyName: "value",
          Value:
            "Pastel Design Patron Ekranı, Detay Yazılım tarafından geliştirilen ERP entegre bir mobil uygulamadır. Uygulama ile ilgili her türlü destek talebi için aşağıdaki iletişim kanallarını kullanabilirsiniz.",
        },
        {
          Id: 901508,
          PropertyName: "value",
          Value: "Şirket: Detay Yazılım Uygulama: Pastel Design Patron Ekranı",
        },
        {
          Id: 462423,
          PropertyName: "value",
          Value: "E-posta: mert@detayyazilim.net",
        },
        {
          Id: 716076,
          PropertyName: "value",
          Value: "Telefon: +90 532 640 3296",
        },
        { Id: 609983, PropertyName: "value", Value: "Destek Kapsamı:" },
        {
          Id: 7974,
          PropertyName: "value",
          Value: "Kullanıcı girişi ve erişim sorunları",
        },
        {
          Id: 73983,
          PropertyName: "value",
          Value: "Sipariş, stok ve fatura işlemleri",
        },
        {
          Id: 19926,
          PropertyName: "value",
          Value: "ERP entegrasyonu ve veri senkronizasyonu",
        },
        {
          Id: 18677,
          PropertyName: "value",
          Value: "Teknik hata ve performans sorunları",
        },
        { Id: 299138, PropertyName: "value", Value: "Genel kullanım desteği" },
        { Id: 296357, PropertyName: "value", Value: "Genel kullanım desteği" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("support", "");
      return;
    }

    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("support", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("support", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
